import "uitoolkit/index.scss"; // this must be the first import, so layers get defined before use
import "./index.scss";
import { h, render } from "preact";
import Router from "preact-router";
import { LandingPage, LandingPageSimple } from "./pages/landing/landingPage";
import { globalUserState, initUserState, initializeSystemConfig } from "./state";
import { registerServiceWorker } from "./services/registerServiceworker";
import { initTranslations } from "services/translations";
import { App } from "./app";
import { setColorScheme } from "services/utils";
import { useIsPWAStandalone } from "./hooks/isPwa";

function MainRouter() {
    const userState = globalUserState.value.status;

    if (userState == "pending") return <div />;
    const standalone = useIsPWAStandalone();

    return (
        <Router>
            {
                userState === "none" && (standalone ? <LandingPageSimple default /> : <LandingPage default />)
            }
            {
                userState === "loggedin" && <App default />
            }
        </Router>
    );
}

registerServiceWorker();
initializeSystemConfig();
initUserState();
initTranslations();

//setColorScheme("light");

render(<MainRouter />, document.getElementById("app")!);
